
import ViewModel from '@/models/ViewModel'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class InputLoader extends ViewModel {
  @Prop({ default: false })
  public is_loading!: boolean
}
